import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "validationErrorBody" })
export class ValidationErrorBodyPipe implements PipeTransform {
   public transform(errors: Array<string>, errorStatus: number): Array<string> {
      switch (errorStatus) {
         case 400:
            return errors;
         case 403:
            return ["MC_NO_ACCESS"];
         default:
            return ["MC_GENERAL_ERROR_MESSAGE"];
      }
   }
}
